import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../contexts/internal/StickyContext.js';
import { EditorContextProvider } from '../contexts/internal/EditorContext.js';
import { EditorInfoContextProvider } from '../contexts/external/EditorInfoContext.js';
import { EditorComponentsProvider } from '../contexts/EditorComponentsProvider.js';
import '../components/Canvas/Canvas.style.js';
import '../components/Canvas/PreviewModeContainer.js';
import '../components/Duration/DurationInput.js';
import 'react-hook-form';
import '../components/FieldItem.js';
import '../components/FormGroup/FormGroup.js';
import '../components/FormGroup/LogDataFormGroup.js';
import { Header as Header$1 } from '../components/Header/index.js';
import '../components/Input/ColorPickerField/index.js';
import '../components/Input/URLInput.js';
import { Inspector } from '../components/Inspector/Inspector.js';
import { TreeList } from '../components/TreeList/TreeList.js';
import '../components/EditorPlaceholder/EditorPlaceholder.js';
import '../components/FormContent.js';
import 'lodash-es';
import { useResizerSidebar } from '../hooks/useResizerSidebar.js';
import { defaultComponents } from './defaultComponents.js';
import { Container, Header, Body, Sider, Panel, Resizer, Canvas } from './Editor.style.js';

function Editor(props) {
  var width = props.width,
    siderWidth = props.siderWidth,
    className = props.className,
    value = props.value,
    onChange = props.onChange,
    newValue = props.newValue,
    components = props.components,
    disableDefaultComponents = props.disableDefaultComponents,
    _props$disableCompone = props.disableComponentIds,
    disableComponentIds = _props$disableCompone === void 0 ? [] : _props$disableCompone,
    editorInfoContext = props.editorInfoContext,
    unitContext = props.unitContext,
    _props$displayDate = props.displayDate,
    displayDate = _props$displayDate === void 0 ? new Date() : _props$displayDate;
  var _useResizerSidebar = useResizerSidebar('right', siderWidth),
    _useResizerSidebar2 = _slicedToArray(_useResizerSidebar, 3),
    rightSidebarRef = _useResizerSidebar2[0],
    startRightSidebarResizing = _useResizerSidebar2[1],
    rightSidebarWidth = _useResizerSidebar2[2];
  var _useResizerSidebar3 = useResizerSidebar('left', siderWidth),
    _useResizerSidebar4 = _slicedToArray(_useResizerSidebar3, 3),
    leftSidebarRef = _useResizerSidebar4[0],
    startLeftSidebarResizing = _useResizerSidebar4[1],
    leftSidebarWidth = _useResizerSidebar4[2];
  var filteredDefaultComponents = React__default.useMemo(function () {
    disableComponentIds.forEach(function (id) {
      delete defaultComponents[id];
    });
    return defaultComponents;
  }, [disableComponentIds]);
  return jsx(EditorContextProvider, {
    value: value,
    onChange: onChange,
    newValue: newValue,
    editorType: "editor",
    displayDate: displayDate,
    components: _objectSpread2(_objectSpread2({}, disableDefaultComponents ? {} : filteredDefaultComponents), components !== null && components !== void 0 ? components : {})
  }, jsx(EditorInfoContextProvider, {
    value: editorInfoContext
  }, jsx(EditorComponentsProvider, {
    contexts: unitContext
  }, jsx(Container, {
    className: className
  }, jsx(Header, null, jsx(Header$1, null)), jsx(Body, null, jsx(Sider, {
    width: leftSidebarWidth,
    ref: leftSidebarRef
  }, jsx(Panel, null, jsx(TreeList, null)), jsx(Resizer, {
    right: true,
    onMouseDown: startLeftSidebarResizing
  })), jsx(Canvas, {
    id: "canvas",
    width: width,
    className: className
  }), jsx(Sider, {
    width: rightSidebarWidth,
    ref: rightSidebarRef
  }, jsx(Resizer, {
    left: true,
    onMouseDown: startRightSidebarResizing
  }), jsx(Panel, null, jsx(Inspector, null))))))));
}

export { Editor };
//# sourceMappingURL=Editor.js.map
